/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScreenerInsuranceType = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Other: 'Other',
} as const;
export type ScreenerInsuranceType = typeof ScreenerInsuranceType[keyof typeof ScreenerInsuranceType];


export function instanceOfScreenerInsuranceType(value: any): boolean {
    for (const key in ScreenerInsuranceType) {
        if (Object.prototype.hasOwnProperty.call(ScreenerInsuranceType, key)) {
            if (ScreenerInsuranceType[key as keyof typeof ScreenerInsuranceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScreenerInsuranceTypeFromJSON(json: any): ScreenerInsuranceType {
    return ScreenerInsuranceTypeFromJSONTyped(json, false);
}

export function ScreenerInsuranceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerInsuranceType {
    return json as ScreenerInsuranceType;
}

export function ScreenerInsuranceTypeToJSON(value?: ScreenerInsuranceType | null): any {
    return value as any;
}

export function ScreenerInsuranceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ScreenerInsuranceType {
    return value as ScreenerInsuranceType;
}

